import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { rutFormat } from 'rut-helpers';


@Directive({
  selector: '[appInputRut]',
})
export class InputRutDirective {

  constructor(
    private el: ElementRef,
    private control: NgControl,
  ) { }

  @HostListener('input', ['$event']) onInput($event) {
    if (this.el.nativeElement.value) {
      const newValue = rutFormat(this.el.nativeElement.value);
      this.control.control.setValue(newValue);
    }
  }

}
